import type { FunctionComponent } from "react";
import BrandManagersSliderMenuPartial from "../../../../partials/admin/menus/campaign/brand-managers-slider.admin.partials";

export const BrandManagersSliderMenuAdminScreen: FunctionComponent = () => {
    return <BrandManagersSliderMenuPartial />;
};
